import { Anchor } from "~/components/Anchor";
import { MediaCitation } from "../../types";
import { ImageLoader } from "~/components/ImageLoader";
import { RWA_COIN_ICON } from "~/consts";
import { MediaCitationsUserEvents } from "~/modules/analytics/events/media_citations";
import { formatCitationDate } from "./formatCitationDate";
import { CITATION_FALLBACK_IMAGE_URL } from "./consts";

// // // //

export function CitationCard(props: { citation: MediaCitation }) {
    const { citation } = props;

    return (
        <Anchor
            href={citation.url}
            analyticsLabel={MediaCitationsUserEvents.ClickCitationCard}
            analyticsEventProperties={{
                citationTitle: citation.title,
                publisherName: citation.publisher.name,
            }}
            className="group flex flex-col overflow-hidden rounded-xl border bg-card transition-shadow hover:shadow-lg hover:bg-blue-50"
            openInNewTab
        >
            <div className="relative h-36 shrink-0 overflow-hidden border-b bg-accent">
                <ImageLoader
                    src={citation.image_url}
                    alt={citation.title}
                    className="absolute inset-0 h-full w-full object-cover"
                    fallbackSrc={CITATION_FALLBACK_IMAGE_URL}
                />
            </div>

            <div className="flex flex-1 flex-col gap-2.5 px-4.5 pt-4 pb-4.5">
                <div className="flex items-center gap-2">
                    <ImageLoader
                        src={citation.publisher.icon_url || RWA_COIN_ICON}
                        alt={`${citation.publisher.name} icon`}
                        className="size-4.5 shrink-0 rounded object-contain"
                        fallbackSrc={RWA_COIN_ICON}
                    />
                    <span className="truncate text-xs text-muted-foreground">
                        {citation.publisher.name}
                    </span>
                </div>

                <h3 className="text-base font-medium leading-5 tracking-[-0.01em] text-foreground line-clamp-3">
                    {citation.title}
                </h3>

                <div className="mt-auto flex items-center justify-between pt-0.5">
                    <span className="text-xs font-light text-muted-foreground">
                        {formatCitationDate(citation.published_date)}
                    </span>
                    <span className="inline-flex h-5 items-center rounded-full bg-primary-light px-2 text-[11px] font-light text-primary">
                        {citation.is_pdf ? "Institutional Report" : "Media"}
                    </span>
                </div>
            </div>
        </Anchor>
    );
}
